import { defineComponent } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import SmeSupportForm from "../../components/SmeSupportForm";

export default defineComponent({
    components: {
        SmeLayout,
        SmeSupportForm,
    },

    template: `
        <SmeLayout class="StepSmeMultiplePpe">
            <h1 class="title-1 mt-0">Na Twojej fakturze widnieje kilka PPE</h1>

            <div class="SmeSupportFormBox contentbox contentbox--white">
                <h2 class="title-2">Mamy specjalną ofertę dla dużych Klientów</h2>

                <SmeSupportForm type="multipleppe">
                    <p class="SmeSupportFormBox__text">Wypełnij formularz, a nasz Doradca skontaktuje się z Tobą w sprawie indywidualnej oferty dla Twojej firmy.</p>
                </SmeSupportForm>

                <button type="button" class="button button--secondary button--full m-20" @click="$emit('otherinvoice')">Wgraj inną fakturę</button>
            </div>
        </SmeLayout>
    `,

    emits: [
        'otherinvoice',
    ],

    props: {
    },

    setup(props, ctx) {
        return {
        };
    },
});
